module.exports = __webpack_public_path__ + "img/moveout-2.94de026e.jpg";